import {useSelector} from "react-redux";
import {IStore} from "../../../slices/types/Store";

export const useCatalogSessionState = () => {
  return useSelector((state: IStore) => state.catalogSession);
};
